import React, { memo, useRef, useState, useEffect, useCallback, Component } from 'react';
import {getPagination} from 'components/pianoroll/PianoRollPagination.js';
import StepData from 'pattern/StepData.js';
import Track from 'track/Track.js';
import Notes from 'midi/Notes.js';
import { connect } from "react-redux";
import Resolution from 'engine/Resolution.js';
import {mouseDown} from 'actions/index.js';
import {dragToggle} from 'actions/index.js';
import {dragStepTranspose} from 'actions/index.js';
import {setStepDragging} from 'actions/index.js';
import {setStepDataDragging} from 'actions/index.js';
import {setStepAndDataDragging} from 'actions/index.js';
import {setStepToCopy} from 'actions/index.js';
import {setIsDraggingDuration} from 'actions/index.js';
import {setPianoRollSelection} from 'actions/index.js';
import {
    setSampleExplorerSelected,
    setSelectedPianoRollSteps,
    setSelectedFreeze
} from 'actions/index.js';
import {setTransposeDragging} from 'actions/index.js';
import {setPianoRollDragOffset} from 'actions/index.js';
import {
    addStep,
    updateStepParameter,
    deleteSteps,
    moveSteps,
    snapToGrid
} from 'operations/actions.js';
import {WIDTH, LEFT_SPACE} from '../pianoroll/constants.js';
import {useGridStyle} from './useGridStyle.js';
import {useGridMouse} from './useGridMouse.js';
import Colors from 'components/Colors.js';
const colors = new Colors();

const DURATION_RESOLUTION = new Resolution(16, false);
const baseResolution = Track.baseResolution;

const PianoRollGridStep = memo((props) => { 
    const {
        isGuideStep,
        noteIndex,
        isAlternateColor,
        sequencerEngine,
        selectedPianoRollSteps,
        stepData,
        height,
        duration,
        color,
        xScale,
        resolution,
        position,
        stepNumber,
        parentClassName,
        setPianoRollDragOffset,
        mouseDown,
        setDragStepTranspose,
        setStepDragging,
        setStepToCopy,
        setTransposeDragging,
        setSelectedPianoRollSteps,
    } = props;

    const {style, className, slideStyle} = useGridStyle(props);
    const {onMouseDown, onMouseUp, dragStepDuration} = useGridMouse(props);
    let note = sequencerEngine.store.getState().keyboard.notes[noteIndex] ||
        Notes.NOTES[0];

    return (
        <div
          style={style}
          onMouseDown={onMouseDown}
          onMouseUp={onMouseUp}
          className={className + " grid-step toggled-grid-step on"}>
          {!isGuideStep ?
           <div className="grid-note">
             {note.toString()}
           </div> : ''}
          {!isGuideStep && stepData.slide ? <div style={slideStyle} className="grid-slide"/> : ''}
          <div
            draggable={false}
            onMouseDown={dragStepDuration}
            className="right-edge"></div> 
        </div>
    );
});

const mapDispatchToProps = (dispatch, props) => {
    return {
        mouseDown: m => dispatch(mouseDown(m)),
        dragToggle: m => dispatch(dragToggle(m)),
        setStepDragging: step  => dispatch(setStepDragging(step)),
        setStepToCopy: step  => dispatch(setStepToCopy(step)),
        setTransposeDragging: transpose => dispatch(setTransposeDragging(transpose)),
        setDragStepTranspose: transpose => dispatch(dragStepTranspose(transpose)),
        setIsDraggingDuration: isDraggingDuration => dispatch(setIsDraggingDuration(isDraggingDuration)),
        setStepDataDragging: stepData => dispatch(setStepDataDragging(stepData)),
        setStepAndDataDragging: (stepNumber, stepData) => dispatch(setStepAndDataDragging(stepNumber, stepData)),
        setPianoRollSelection: (stepNumber, transpose, numSteps, numNotes) =>
            dispatch(setPianoRollSelection(stepNumber, transpose, numSteps, numNotes)),
        setSelectedPianoRollSteps: (steps) => dispatch(setSelectedPianoRollSteps(steps)),
        setPianoRollDragOffset: (offset) => dispatch(setPianoRollDragOffset(offset)),
        setSelectedFreeze: (freeze) => dispatch(setSelectedFreeze(freeze)),
        setSampleExplorerSelected: (x) => dispatch(setSampleExplorerSelected(x)),
    }
};

export default connect(null,  mapDispatchToProps)(PianoRollGridStep);
